module.exports = __webpack_public_path__ + "static/media/2.1379d8d8.jpg";